import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

const config: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID as string}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    // How long a hidden renewal iframe may take before MSAL gives up (default 10s). A dead Entra
    // session normally answers in well under a second, so a wait this long means the iframe cannot
    // complete at all, and every second of it is a second the user stares at a page that will not
    // load.
    iframeBridgeTimeout: 5000,
  },
};

export const msalInstance = new PublicClientApplication(config);

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

/**
 * Where MSAL's hidden renewal iframe lands: `public/blank.html`, a page with no app in it.
 *
 * Not the app root (`redirectUri` above). Loading the app inside its own renewal iframe makes MSAL
 * refuse with `block_iframe_reload`, so renewal can never succeed and every 401 retries forever.
 * The interactive sign-in keeps the app root, since that redirect is meant to load the app.
 *
 * Must be registered as a SPA redirect URI in the Entra app registration, for every origin the UI
 * is served from. Until it is, Entra answers the iframe with a redirect-mismatch page and renewal
 * times out; `session.ts` caps consecutive failures so that still ends at the sign-in page.
 */
export const SILENT_REDIRECT_URI = `${window.location.origin}/blank.html`;

/** The request every `acquireTokenSilent` call uses. Never pass `loginRequest` to a silent call. */
export const silentRequest = { ...loginRequest, redirectUri: SILENT_REDIRECT_URI };
